import { Flex, Text } from '@chakra-ui/react';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ButtonText,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@morressier/alembic';

const SubmissionActionMenu = ({
  submissionId,
  submissionContextId,
  handleClick,
  isReview = false,
  isViewDisabled = false,
  handleContactClick
}: {
  submissionId: string;
  submissionContextId?: string;
  handleClick: (
    submissionId: string,
    submissionContextId?: string,
    activeTab?: string
  ) => void;
  isReview?: boolean;
  isViewDisabled?: boolean;
  handleContactClick?: (
    submissionId: string,
    submissionContextId?: string
  ) => void;
}) => {
  return (
    <Menu ariaLabel="normal menu">
      <MenuButton aria-label="Open submission actions">
        <ButtonText aria-label="Open submission actions">
          <Flex gap={2} alignItems="center">
            <FontAwesomeIcon size="lg" icon={faBars} />
          </Flex>
        </ButtonText>
      </MenuButton>

      {submissionContextId ? (
        <MenuList>
          <MenuItem
            ariaLabel={'View Submission'}
            onClick={() =>
              handleClick(submissionId, submissionContextId, 'overview')
            }
          >
            <Text textStyle="context">View Overview</Text>
          </MenuItem>{' '}
          <MenuItem
            ariaLabel={'View Reviews'}
            onClick={() =>
              handleClick(submissionId, submissionContextId, 'reviews')
            }
          >
            <Text textStyle="context">View Reviews</Text>
          </MenuItem>{' '}
          <MenuItem
            ariaLabel={'View Backoffice'}
            onClick={() =>
              handleClick(submissionId, submissionContextId, 'backoffice')
            }
          >
            <Text textStyle="context">View Backoffice</Text>
          </MenuItem>{' '}
          <MenuItem
            ariaLabel={'View Integrity'}
            onClick={() =>
              handleClick(submissionId, submissionContextId, 'integrity')
            }
          >
            <Text textStyle="context">View Integrity</Text>
          </MenuItem>
        </MenuList>
      ) : (
        <MenuList>
          <MenuItem
            ariaLabel={'View Submission'}
            disabled={isViewDisabled}
            onClick={() => handleClick(submissionId)}
          >
            <Text textStyle="context">
              View {isReview ? 'Review' : 'Feedback'}
            </Text>
          </MenuItem>
          {handleContactClick && (
            <MenuItem
              ariaLabel={'Contact Journal'}
              onClick={() => handleContactClick(submissionId)}
            >
              <Text textStyle="context">Contact Journal</Text>
            </MenuItem>
          )}
        </MenuList>
      )}
    </Menu>
  );
};

export default SubmissionActionMenu;
